import styles from './PolaroidPhoto.module.scss';

type PolaroidPhotoProps = {
  src: string;
  alt: string;
  caption?: string;
};

export function PolaroidPhoto({ src, alt, caption }: PolaroidPhotoProps) {
  return (
    <figure className={styles.polaroid} aria-label="Polaroid photo">
      <div className={styles.image} style={{ backgroundImage: `url(${src})` }} />
      {caption ? <figcaption className={styles.caption}>{caption}</figcaption> : null}
    </figure>
  );
}